import React from "react";
import { FiCamera } from "react-icons/fi";

function ImageSelector(props) {
  const {
    existingImage,
    classes,
    icon,
    setSelectedImage,
    key_name,
    handleChange,
    openSnackBar,
    disab,
  } = props;
  function handleImageClick() {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = "image/*";
    fileInput.onchange = () => {
      const file = fileInput.files[0];
      if (file) {
        // Use a FileReader to read the selected image as a data URL
        const reader = new FileReader();
        reader.onload = (e) => {
          const dataURL = e.target.result;
          setSelectedImage(dataURL);
          if (key_name === "templateImage") {
            if (isImageFile(file)) {
              let event = { target: { name: key_name, value: file } };
              handleChange(event);
            } else {
              const files = new File(
                [""],
                "../../../assets/DigitalMarketing/image/no-image.jpg",
                { type: "image/jpeg" }
              );
              const fileList = new DataTransfer();
              fileList.items.add(files);

              // Set the FileList object to the files property of the file input element
              fileInput.files = fileList.files;
            }
          } else {
            let event = { target: { name: key_name, value: file } };
            handleChange(event);
          }
        };

        if (key_name === "templateImage") {
          if (isImageFile(file)) {
            reader.readAsDataURL(file);
          } else {
            openSnackBar("Invalid file format use image only", "error");
          }
        } else {
          reader.readAsDataURL(file);
        }
      }
    };
    fileInput.click();
  }
  function isImageFile(value: any): boolean {
    return value instanceof File && value.type.startsWith("image/");
  }
  return (
    <>
      {existingImage ? (
        <div className="setting-img me-3">
          <img
            src={existingImage}
            onClick={disab ? undefined : handleImageClick}
            className={`${classes} me-3 cursur`}
            alt=""
          />
          {icon && (
            <div onClick={disab ? undefined : handleImageClick}>
              <FiCamera className="blue-c cursur" />
            </div>
          )}
        </div>
      ) : (
        <div className="setting-img me-3">
          <img
            src={require("../../assets/DigitalMarketing/image/user.jpeg")}
            onClick={disab ? undefined : handleImageClick}
            className={`${classes} me-3 cursur`}
            alt=""
          />
          {icon && (
            <div onClick={disab ? undefined : handleImageClick}>
              <FiCamera className="blue-c cursur" />
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default React.memo(ImageSelector);
